import BaseViewController from "./base-view-controller";

class ExpertMedicalOpinionOnlyAdultViewController extends BaseViewController {
  handleButtonClick(action) {
    this.appData.onExit(action?.value);
    return;
  }
}
export default ExpertMedicalOpinionOnlyAdultViewController;
